import React from 'react'
import _ from 'lodash'

import TextField from '../../Components/TextField.component'
import Radio from '../../Components/Radio.component'
import Select from '../../Components/Select.component'
import SelectMultiple from '../../Components/SelectMultiple.component'
import DateTimePicker from '../../Components/DateTimePicker.component'

const omit = ['inputtype']

export default props => {
  switch (props.inputtype.toLowerCase()) {
    case 'string':
      return (
        <TextField
          {..._.omit(props, omit)}
        />
      )
    case 'number':
      return (
        <TextField
          {..._.omit(props, omit)}
          type='number'
        />
      )
    case 'radio':
      return (
        <Radio
          {..._.omit(props, omit)}
        />
      )
    case 'select':
      return (
        <Select
          {..._.omit(props, omit)}
        />
      )
    case 'checkbox':
      return (
        <SelectMultiple
          {..._.omit(props, omit)}
        />
      )
    case 'date':
      return (
        <DateTimePicker {..._.omit(props, omit)} />
      )
    default:
      return (
        <TextField {..._.omit(props, omit)} />
      )
  }
}
